@if (showAppShell()) {
  <rds-header
    (logoTriggered)="goHome()"
    [minimalMargins]="true"
  >
    <rds-header-app-name (triggered)="goHome()">PDMA Capability Gap Assessment</rds-header-app-name>
    <rds-header-navigation-primary>
      @if (showPrimaryNav()) {
        @for (nav of primaryNavigation(); track nav.routerLink) {
          <rds-header-link [routerLink]="nav.routerLink" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: nav.routerLink === '/' }">{{ nav.label }}</rds-header-link>
        }
      }
    </rds-header-navigation-primary>
    <rds-header-actions>
      @if (authService.isAuthenticated()) {
        <button rds-icon-button size="m" aria-label="Notifications">
          <rds-icon namespace="outlined" icon="notification" />
        </button>
        @if (authService.isAdmin()) {
          <button rds-icon-button size="m" aria-label="Settings" [routerLink]="'/admin'">
            <rds-icon namespace="outlined" icon="settings" />
          </button>
        }
        <button rds-text-button (click)="authService.logout()">Sign Out</button>
      }
    </rds-header-actions>
  </rds-header>
}

<main [class]="showAppShell() ? 'app-content' : ''" [@routeAnimation]="getRouteAnimationData()">
  <router-outlet></router-outlet>
</main>

@if (showAppShell()) {
  <footer rds-footer>
    <rds-footer-navigation>
      <rds-footer-link (click)="openPrivacyNotice()">Privacy Notice</rds-footer-link>
      <rds-footer-link (click)="openTermsOfUse()">Terms of Use</rds-footer-link>
      <rds-footer-link (click)="openSupport()">Support</rds-footer-link>
    </rds-footer-navigation>
  </footer>
}
